import { useCallback, useEffect, useRef, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Slider from "react-slick";
import CustomImage from "../CustomImage";
import format from "date-fns/format";
import { formatOrder } from "../../utils/constants";
import fetchUtil from "../../utils/fetchUtil";
import LazyReveal from "../LazyReveal";
import CardShimmer from "./CardShimmer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface IBlogsList {
  detailData: any;
  styles?: any;
  pathCondition?: boolean;
  settings?: any;
}

const BlogsList: React.FC<IBlogsList> = ({
  detailData,
  styles,
  pathCondition,
  settings,
}) => {
  const [latestBlogs, setLatestBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const sliderRef = useRef<Slider>(null);
  const [isVisible, setIsVisible] = useState(false);

  const onVisible = useCallback(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    if (!isVisible) {
      return;
    }
    setIsLoading(true);
    fetchUtil(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/blogs?_sort=date:DESC&_start=0&stu_dest_categories.category_ncontains=News&_limit=20`,
      "GET",
      {},
      "",
      false
    ).then((res: any) => {
      setLatestBlogs(res);
      setIsLoading(false);
    });
  }, [isVisible]);

  return (
    <LazyReveal shimmer={<CardShimmer />} onVisible={onVisible}>
      <>
        {isLoading && <CardShimmer />}
        {!isLoading &&
          (latestBlogs.length > 0 ? (
            <>
              <Slider
                {...settings}
                slidesToShow={latestBlogs.length < 3 ? latestBlogs.length : 3}
                ref={sliderRef}
                className={`${styles.slider} ${styles.mobileCultureSlider}`}
              >
                {latestBlogs.map((blog: any, index: number) => {
                  return (
                    <div className={styles.allnews} key={index}>
                      <Row className="text-center">
                        <a
                          href={
                            detailData.isExternalLink && detailData.externalLink
                              ? detailData.externalLink
                              : `/${pathCondition ? "news" : "blogs"}/${
                                  blog.slug
                                }`
                          }
                        >
                          <Col lg={12} md={12} sm={12}>
                            <Card className={styles.card}>
                              <div className={styles.cardImg}>
                                <CustomImage
                                  src={
                                    blog.blogLandingCardImage?.imageUrl
                                      ? blog.blogLandingCardImage.imageUrl
                                      : blog.newimageUrl?.imageUrl
                                  }
                                  alt={
                                    blog.blogLandingCardImage?.alt
                                      ? blog.blogLandingCardImage.alt
                                      : blog.newimageUrl?.alt
                                  }
                                  width={370}
                                  height={220}
                                  object-fit="fill"
                                  layout="responsive"
                                />
                              </div>
                              <Card.Body className={styles.cardBody}>
                                {blog.category && (
                                  <h6 className={styles.blogsCategories}>
                                    {blog.category}
                                  </h6>
                                )}
                                <h5>{blog.title}</h5>
                                {blog.shortDescription && (
                                  <p className={styles.shortDescription}>
                                    {blog.shortDescription}
                                  </p>
                                )}
                                <div className={styles.bottom}>
                                  <span>
                                    {format(new Date(blog.date), formatOrder)}
                                  </span>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        </a>
                      </Row>
                    </div>
                  );
                })}
              </Slider>
              <div className={styles.arrowsClasses}>
                <div
                  className={styles.btcircle}
                  onClick={() => sliderRef?.current?.slickPrev()}
                >
                  <CustomImage
                    src="/new-images/left-arrow.svg"
                    height={17}
                    width={10}
                    alt={"left-arrow"}
                  />
                </div>
                <div
                  className={styles.btcircle}
                  onClick={() => sliderRef?.current?.slickNext()}
                >
                  <CustomImage
                    src="/new-images/right-arrow.svg"
                    height={17}
                    width={10}
                    alt={"right-arrow"}
                  />
                </div>
              </div>
            </>
          ) : (
            "No Related Blogs"
          ))}
      </>
    </LazyReveal>
  );
};

export default BlogsList;
